import { NegotiationDetail, EntityTypeEnum, SettlementVenue } from 'api'
import { createSelector } from '@reduxjs/toolkit'
import { isNotNil } from 'utils/predicate'
import { createAllEntitiesSelector } from './entitySelectors'
import { createTradingEntityHasSellSideRelationshipWithFunds } from './tradingEntitySelectors'
import { GlobalState } from 'store'
import { ParametricSelector } from 'utils/redux'

export const createSettlementVenuesIncomingUSSettlementSelector = <T>(
  negotiationDetailSelector: ParametricSelector<GlobalState, T, NegotiationDetail>
) =>
  createSelector(
    [negotiationDetailSelector, createAllEntitiesSelector(EntityTypeEnum.TRADING_RELATIONSHIP)],
    ({ orderFund, counterparty }, tradingRelationships) => {
      const hasRelationship =
        isNotNil(orderFund) && isNotNil(counterparty)
          ? createTradingEntityHasSellSideRelationshipWithFunds([orderFund.id], tradingRelationships, true, [])(counterparty)
          : false
      return hasRelationship ? [SettlementVenue.Bilateral, SettlementVenue.Sponsored] : [SettlementVenue.Bilateral]
    }
  )
